/**
 * @typedef {import('../../../api-v2/js-doc').V1CreateProcessingNotesRequest} V1CreateProcessingNotesRequest
 * @typedef {import('../../../api-v2/js-doc').V2CreateProcessingNotesRequest} V2CreateProcessingNotesRequest
 * @typedef {import('../../../api-v2/js-doc').V1UpdateProcessingNotesRequest} V1UpdateProcessingNotesRequest
 * @typedef {import('../../../api-v2/js-doc').V2UpdateProcessingNotesRequest} V2UpdateProcessingNotesRequest
 */
export class ProcessingNotesMapper {
  /**
   * @param {V1CreateProcessingNotesRequest} v1Request - V1 create request body
   * @returns {V2CreateProcessingNotesRequest}
   */
  static v1CreateRequestToV2CreateRequest (v1Request) {
    return {
      __ingestThrough: true,
      __v1Payload: {},
      notes: v1Request.notes,
      clientId: v1Request.client_id,
      brokerId: v1Request.debtor_id,
    }
  }

  /**
   * @param {V1UpdateProcessingNotesRequest} v1Request - V1 update request body
   * @returns {V2UpdateProcessingNotesRequest}
   */
  static v1UpdateRequestToV2UpdateRequest (v1Request) {
    return {
      __ingestThrough: true,
      __v1Payload: {},
      notes: v1Request.notes,
      clientId: v1Request.client_id,
      brokerId: v1Request.debtor_id,
    }
  }
}

